import React from "react";
import "../../App.css";
import Footer from "./Footer";

export default function Tickets() {
  return (
    <>
      <div class="tickets">
        <h1>GET TICKETS</h1>
        <ul class="TRVLicons">
          <i class="fas fa-ship" />
          <i class="fas fa-train" />
          <i class="fas fa-plane" />
        </ul>
      </div>
      <Footer />
    </>
  );
}
